export const actionTypes = {
  SET_HOME_PAGE: 'SET_HOME_PAGE'
}

export const setHomePage = (payload) => ({
  type: actionTypes.SET_HOME_PAGE,
  payload
})
